import { useQuery } from '@tanstack/react-query';
import type { Query, WorkOrderPlanType } from '@/@types/Mesh';
import { useParams } from '@/providers/RouterShim';
import type { RequestState } from '../../@types/RequestState';
import { getGql } from '../../fetch';
import { getExternalView } from '../../utils/market';
import { GET_WORK_ORDER_PLAN_TYPES_QUERY } from './queries/workOrderPlanTypes';

export const GET_WORK_ORDER_PLAN_TYPES_QUERY_KEY = 'GET_WORK_ORDER_PLAN_TYPES_QUERY_KEY';

const useWorkOrderPlanTypes = (): [WorkOrderPlanType[] | undefined, RequestState] => {
  const { branchId } = useParams();
  const external = getExternalView() === 'operations' ? 'external' : undefined;
  const xOwnerId = external || branchId;

  const { data, isLoading, isSuccess, isError } = useQuery<Query>({
    queryKey: [GET_WORK_ORDER_PLAN_TYPES_QUERY_KEY, xOwnerId],
    queryFn: async ({ signal }) => {
      return getGql<Query>(
        `${process.env.NEXT_PUBLIC_MESH_URI}/graphql`,
        GET_WORK_ORDER_PLAN_TYPES_QUERY,
        {},
        signal,
        xOwnerId,
      );
    },
    enabled: !!xOwnerId,
  });

  return [data?.workOrderPlanTypes, { isLoading, isSuccess, isError }];
};

export default useWorkOrderPlanTypes;
